import React from 'react'
import { cn } from '@/lib/utils'
import EmptyStarIcon from '@/assets/builder/icon/EmptyStars'
import FilledStarIcon from '@/assets/builder/icon/FilledStar'

interface RatingScaleProps {
    displayType?: 'star' | 'emoji' | 'number'
    minLabel?: string
    maxLabel?: string
    selectedValue?: number
}

const RatingScale: React.FC<RatingScaleProps> = ({
    displayType = 'number',
    minLabel = 'Terrible',
    maxLabel = 'Excellent',
    selectedValue,
}) => {
    const minRating = 1
    const maxRating = 5
    const divisions = maxRating - minRating + 1
    if (displayType === 'star') {
        return (
            <div>
                <div className="flex justify-between w-full gap-2 mt-4">
                    {Array.from({ length: divisions }).map((_, index) => (
                        <div key={index} className="">
                            {selectedValue &&
                            index + minRating <= Number(selectedValue) ? (
                                <FilledStarIcon fill="#FFD82C" />
                            ) : (
                                <EmptyStarIcon />
                            )}
                        </div>
                    ))}
                </div>
                <div className="flex w-full mt-3 px-2 text-sm text-[#222] font-medium">
                    <span className="flex-1 text-left">{minLabel}</span>
                    <span className="flex-1 text-right">{maxLabel}</span>
                </div>
            </div>
        )
    }
    if (displayType === 'emoji') {
        // Emoji scale for rating
        const emojiLabels = [
            { emoji: '😡', label: 'Terrible' },
            { emoji: '🙁', label: 'Bad' },
            { emoji: '🙂', label: 'Good' },
            { emoji: '😁', label: 'Very good' },
            { emoji: '🤩', label: 'Excellent' },
        ]
        return (
            <div className="flex justify-between w-full mt-4">
                {emojiLabels.map((item, index) => {
                    const value = index + 1
                    const isActive =
                        selectedValue && value === Number(selectedValue)
                    return (
                        <div
                            key={index}
                            className={cn(
                                'flex flex-col items-center justify-center px-2 py-1 rounded-lg transition',
                                isActive ? 'bg-gray-200' : 'bg-transparent'
                            )}
                            style={{ minWidth: 20 }}
                        >
                            <span className="mb-1 text-lg">{item.emoji}</span>
                            <span className="text-[12px] whitespace-nowrap font-medium text-[#222]">
                                {item.label}
                            </span>
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <div className="w-full max-w-[470px] mt-4">
            <div className="flex w-full">
                {Array.from({ length: divisions }).map((_, index) => (
                    <div
                        key={index}
                        className={cn(
                            'flex-1 h-[56px] flex items-center justify-center text-md font-semibold transition-all border border-[#DEDEDE] bg-white',
                            selectedValue !== undefined &&
                                Number(selectedValue) === index + minRating &&
                                'bg-[#F3F4F6] border border-gray-400 text-[#222] font-bold',
                            index === 0 && 'rounded-l-lg',
                            index === divisions - 1 && 'rounded-r-lg'
                        )}
                        style={{ minWidth: 0 }}
                    >
                        {index + minRating}
                    </div>
                ))}
            </div>
            <div className="flex w-full mt-3 px-2 text-sm text-[#222] font-medium">
                <span className="flex-1 text-left">{minLabel}</span>
                <span className="flex-1 text-right">{maxLabel}</span>
            </div>
        </div>
    )
}

export default RatingScale
